import { render } from "./PartsAddToCatalog.vue?vue&type=template&id=01da41b0"
import script from "./PartsAddToCatalog.vue?vue&type=script&lang=js"
export * from "./PartsAddToCatalog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__